/**
 * This function takes an amount of seconds and
 * turns it into a valid duration string as
 * described in the HTML standard:
 *
 * https://html.spec.whatwg.org/multipage/common-microsyntaxes.html#valid-duration-string
 */

const DAY_IN_MILLISECONDS = 86400000;
const HOUR_IN_MILLISECONDS = 3600000;
const MINUTE_IN_MILLISECONDS = 60000;
const SECOND_IN_MILLISECONDS = 1000;
const ZERO_DURATION = 'PT0S';

export const secondsToDurationString = (seconds: number): string => {
  if (seconds <= 0) {
    return ZERO_DURATION;
  }

  let remainingTime = seconds * 1000;
  const days = Math.floor(remainingTime / DAY_IN_MILLISECONDS);
  remainingTime -= days * DAY_IN_MILLISECONDS;
  const hours = Math.floor(remainingTime / HOUR_IN_MILLISECONDS);
  remainingTime -= hours * HOUR_IN_MILLISECONDS;
  const minutes = Math.floor(remainingTime / MINUTE_IN_MILLISECONDS);
  remainingTime -= minutes * MINUTE_IN_MILLISECONDS;
  const secs = Math.floor(remainingTime / SECOND_IN_MILLISECONDS);
  remainingTime -= secs * SECOND_IN_MILLISECONDS;
  const milliseconds = remainingTime;
  let returnValue = 'P';
  if (days) {
    returnValue += `${days}D`;
  }
  if (hours || minutes || secs || milliseconds) {
    returnValue += `T`;
    if (hours) {
      returnValue += `${hours}H`;
    }
    if (minutes) {
      returnValue += `${minutes}M`;
    }
    if (secs || milliseconds) {
      const fractionPart = (milliseconds / 1000).toString().substring(2);
      returnValue += `${secs}${milliseconds ? `.${fractionPart}` : ''}S`;
    }
  }
  return returnValue;
};
